import {
  Additional,
  Responsive,
  Sort,
  TableContextReproducer,
  Grouped,
} from '@apia/table';
import { Accordion, AccordionItem, SimpleButton } from '@apia/components';
import { getLabel } from '@apia/util';
import { QueryController } from '../../../QueryController';
import { FilterTypesComponent } from '../../../FilterTypesComponent';
import { observer } from 'mobx-react-lite';
import { Filter } from '../../../filters/Filter';
import { Box } from '@apia/theme';

export const AdditionalFiltersComponent = observer(
  ({ queryController }: { queryController: QueryController }) => {
    const filterTitle = getLabel('sbtFilters').text;
    const sortTitle = getLabel('titOrderBy').text;
    const filterTypes = getLabel('btnFilterType').text;
    const hasAdditional = !![
      ...queryController.tableController.state.filters.values(),
    ].find((f) => f.filterState.isAdditional || !f.filterState.column);
    const hasFilters = !![
      ...queryController.tableController.state.filters.values(),
    ].find((f) => !f.filterState.isAdditional && f.filterState.column);
    const hasSortable = !![
      ...queryController.tableController.state.columns.values(),
    ].find((c) => !c.showAsAdditional && c.allowSorting !== false);
    const hasFilterTypes =
      !queryController.structure?.hideFilterTypes &&
      queryController.conditions.length > 0;
    const groupFilters = (() => {
      const byGroup = new Map<string, Filter>();
      [...queryController.tableController.state.filters.values()].forEach(
        (f) => {
          const g = f.filterState?.group;
          if (g && g !== '' && !byGroup.has(g)) {
            byGroup.set(g, f);
          }
        },
      );
      return [...byGroup.values()];
    })();
    return (
      <Box
        data-query-filter-scope="additional-filters"
        sx={{
          '.requiredMark': { display: 'none' },
          '.filter__query': {
            border: '1px solid #c6c6c6!important',
          },
          '.filterRenderLabel': {
            display: 'none',
          },
        }}
      >
        <TableContextReproducer
          tableName={queryController.tableController.getTableName()}
        >
          <Accordion className="additionalFiltersContent" singleExpand>
            {hasFilters && (
              <AccordionItem
                id="Responsive"
                defaultExpanded={true}
                buttonProps={{ ariaLabel: filterTitle, label: filterTitle }}
              >
                <Responsive />
              </AccordionItem>
            )}
            {hasAdditional && (
              <AccordionItem
                id="Additional"
                buttonProps={{
                  ariaLabel: window.ADDITIONAL_FILTERS_LABEL,
                  label: window.ADDITIONAL_FILTERS_LABEL,
                }}
              >
                <Additional />
              </AccordionItem>
            )}

            {groupFilters.length > 0 && (
              <>
                {groupFilters.map((g) => (
                  <AccordionItem
                    id={`Group_${g.filterState.group}`}
                    buttonProps={{
                      ariaLabel: getLabel(`${g.filterState.group}`).text,
                      label: getLabel(`${g.filterState.group}`).text,
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'end',
                        gap: 3,
                        width: '100%',
                      }}
                    >
                      <Grouped
                        key={g.filterState.group}
                        tableName={queryController.tableController.getTableName()}
                        group={g.filterState?.group ?? ''}
                      />
                      {g.filterState.addFilter && (
                        <SimpleButton
                          variant="outline-sm"
                          onClick={g.filterState.addFilter}
                        >
                          {getLabel('lblAddFil').text}
                        </SimpleButton>
                      )}
                    </Box>
                  </AccordionItem>
                ))}
              </>
            )}

            {hasSortable && (
              <AccordionItem
                id="Sort"
                buttonProps={{ ariaLabel: sortTitle, label: sortTitle }}
              >
                <Sort />
              </AccordionItem>
            )}
            {hasFilterTypes && (
              <AccordionItem
                id="FilterTypes"
                buttonProps={{ ariaLabel: filterTypes, label: filterTypes }}
              >
                <FilterTypesComponent queryController={queryController} />
              </AccordionItem>
            )}
          </Accordion>
        </TableContextReproducer>
      </Box>
    );
  },
);
